<template>


  <div class="content">
    <div class="wraper_bg wallet">
      <div class="info">
        <div class="info_photo">
          <img :src="userinfo.img_url" alt="">
        </div>
        <div class="info_name">
          <p class="info_name_call">
            {{userinfo.wx_name?userinfo.wx_name:userinfo.name}}
          </p>
          <p class="info_name_uid">uid:{{userinfo.id}}</p>
        </div>
        <div class="info_balance">
          <div class="router-link btn" @click="showRecharge">
            余额充值
          </div>
        </div>
      </div>
      <div class="info_under">
        <div class="info_under_price divide-line right-border">
          <h3 class="info_id">{{userinfo.coupons_num}}</h3>
          <p>优惠券</p>
        </div>
      </div>
    </div>

    <el-tabs v-model="activeStatus" :stretch="true" @tab-click="checkTab">
      <el-tab-pane v-for="(item,index) in trr" :label="item.title" :name="item.status" :key="index">
      </el-tab-pane>
    </el-tabs>

    <div class="infinite-list" style="overflow:auto;background-color: #f5f5f5;" v-infinite-scroll="loadMore"
      infinite-scroll-disabled="busy" infinite-scroll-distance="1">

      <div class='coupon-list'>
        <div class='item acea-row row-center-wrapper' v-for="(row,index) in lists" :key="index">

          <div class='money ' :class="row.status == 0 ? 'moneyGray' : ''">
            <div style="font-weight:normal">₱</div>
            <div class='num'>{{row.amount}}</div>

          </div>
          <div class='text'>
            <div class='condition line1'>{{row.name}}</div>

            <div class='data acea-row row-between-wrapper'>
              <div v-if="row.end_time">{{row.end_time}}</div>
              <div v-else>永久有效</div>
              <div class='bnt gray' v-if='row.status == 0'>已失效</div>
              <div class='bnt bg-color' v-else>未使用</div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div id="loadMore" v-if="droping">加载中...</div>
    <div id="noMore" v-if="noMore" style="text-align: center; margin-top: 50px">没有更多了</div>
    <div class="clear" style="margin-top: 50px"></div>

    <el-dialog title="提示" :visible.sync="rechargeDialogVisible" class="dialog">
      <el-input v-model="amount" placeholder="请输入充值金额（₱）"></el-input>
      <div class="radio-area">
        <el-radio-group v-model="payment" size="small" @change="handleRadioChange">
          <el-radio class="radio-item" :label="item.code" v-for="item in payments" :key="item.code">
            <img :src="'../../static/images/'+item.name+'.png'">
          </el-radio>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer btn-area">
        <el-button @click="rechargeDialogVisible = false" class="btn">取 消</el-button>
        <el-button type="primary" @click="rechargemoney" class="btn">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="请使用扫码支付" :visible.sync="centerDialogVisible" width="300px" center>
      <div>
        <vue-qr :text="downloadData.url" :margin="10" colorDark="#000" colorLight="#fff" :dotScale="1"
          :logoSrc="downloadData.icon" :logoScale="0.2" :size="200"></vue-qr>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <navBar :idx="3"></navBar>
  </div>


</template>
<script>
  const delay = (function() {
    let timer = 0
    return function(callback, ms) {
      clearTimeout(timer)
      timer = setInterval(callback, ms)
    }
  })()

  import navBar from '@/components/navBar';
  import vueQr from 'vue-qr'

  export default {
    name: 'wallet',
    components: {
      navBar,
      vueQr
    },
    data() {
      return {
        rechargeDialogVisible: false,
        centerDialogVisible: false,
        downloadData: {
          url: '', //需要转化成二维码的网址
        },
        userinfo: {},
        amount: '',
        payments: [],
        payment: 'weixin',
        busy: false,
        droping: false,
        noMore: false,
        lists: [],
        page: 0,
        pageSize: 10,
        activeStatus: "0",
        trr: [{
            "title": "全部",
            "status": "0"
          },
          {
            "title": "未使用",
            "status": "1"
          },
          {
            "title": "已使用",
            "status": "2"
          },
          {
            "title": "已过期",
            "status": "3"
          },
        ]
      }
    },
    mounted() {
      this.getUserInfo();
      let payments = localStorage.getItem('payments');
      if (payments) {
        try {
          this.payments = JSON.parse(payments);
        } catch (e) {}
      }
    },
    methods: {
      handleClose: function(done) {
        done();
      },
      checkTab(tab) {
        this.noMore = false;
        this.page = 0;
        this.lists = [];
        this.loadMore();
      },
      loadMore() {
        this.busy = true;
        this.droping = true;
        let auth_token = localStorage.getItem('auth_token');
        if (auth_token) {
          this.page++;
          this.$api
            .request('Coupons/lists', {
              page: this.page,
              pageSize: this.pageSize,
              status: this.activeStatus
            })
            .then(({
              data
            }) => {
              if (data.length <= 0 || data.length < this.pageSize) {
                this.noMore = true;
              } else {
                this.noMore = false;
              }
              data.forEach(item => {
                this.lists.push(item);
              });
              this.busy = false;
              this.droping = false;
            })
            .catch(error => {
              this.$message({
                message: error + "加载优惠券失败!",
                type: "warning"
              })
            });
        } else {
          this.busy = false;
          this.droping = false;
          this.noMore = true;
        }
      },
      getUserInfo() {
        this.$api
          .request('Member/getInfo', {})
          .then(({
            data
          }) => {
            this.userinfo = data;
          })
          .catch(error => {
            this.$message({
              message: error + "获取用户信息失败！",
              type: "warning"
            })
          });
      },
      magpay(params) {
        let config = {
          money: params.pay_amount,
          title: params.description,
          des: params.description,
          payWay: {
            // wallet: 1,
            weixin: 1,
            alipay: 1,
          },
          orderNum: params.oid,
          unionOrderNum: params.order_sn,
          type: params.description
        };
        mag.pay(config, () => {
          setTimeout(() => {
            this.$message({
              message: "支付成功",
              type: "warning"
            })
          }, 50);
        }, () => {
          this.$message({
            message: "支付失败",
            type: "warning"
          })
        });
      },
      wxpay(params) {
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', {
            'appId': params.appId,
            'timeStamp': params.timeStamp,
            'nonceStr': params.nonceStr,
            'package': params.package,
            'signType': params.signType,
            'paySign': params.sign
          },
          (res) => {
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              this.$message({
                message: "支付成功",
                type: "warning"
              })
              this.$router.go(0);
            } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {} else if (res.err_msg ===
              'get_brand_wcpay_request:fail') {
              this.$router.go(0);
            }
          });
      },
      showRecharge() {
        if (!this.payment) {
          let current_payment = this.payments[0];
          this.payment = current_payment.code;
        }
        this.rechargeDialogVisible = true;
      },
      openUrl(url) {
        if (url) {
          window.open(url, '_blank');
        }
        this.$confirm("支付提示", "", {
          iconClass: "el-icon-question", //自定义图标样式
          confirmButtonText: "支付完成", //确认按钮文字更换
          cancelButtonText: "取消", //取消按钮文字更换
          showClose: true, //是否显示右上角关闭按钮
          type: "warning", //提示类型  success/info/warning/error
        }).then((data) => {
          let auth_token = localStorage.getItem('auth_token');
          if (auth_token) {
            this.$router.push('/historycard');
          }
        }).catch((err) => {

        });
      },
      rechargemoney() {
        let exp = /^[1-9]\d*$/;
        if (!exp.test(this.amount)) {
          this.$message({
            message: "请输入正确的金额！",
            type: "warning"
          })
          return;
        }
        this.rechargeDialogVisible = false;
        let settlement = 1;
        if (this.$client == 'wxh5' || (this.$client == 'h5' && this.payment == 'weixin')) {
          settlement = 2;
        }
        this.$api
          .request('Order/create', {
            type: 2,
            settlement: settlement,
            client: this.$client,
            amount: this.amount,
            payment: this.payment
          })
          .then(({
            data
          }) => {
            switch (this.$client) {
              case 'h5':
                switch (data.type) {
                  case "1":
                    if (this.payment == 'gcashpay') {
                      this.openUrl(data.result.data.content);
                    } else {
                      this.centerDialogVisible = true;
                      this.downloadData.url = data.result.data.content;
                    }
                    break;
                  case "2":
                    switch (this.payment) {
                      case "weixin":
                        this.centerDialogVisible = true;
                        this.downloadData.url = data.result.results.qrcode;
                        break;
                      case "alipay":
                        this.centerDialogVisible = true;
                        this.downloadData.url = data.result.results.pay_url;
                        break;
                      case "gcashpay":
                        this.openUrl(data.result.results.api_url);
                        break;
                    }
                    break;
                  default:
                    this.$message({
                      message: "暂不支持的支付类型！",
                      type: "warning"
                    })
                    break;
                }
                delay(() => {
                  this.checkorder(data.result.results.out_trade_no)
                }, 3000)
                break;
              case 'wxh5':
                switch (data.type) {
                  case "1":
                    let params = JSON.parse(data.result.data.content);
                    this.wxpay(params);
                    break;
                  case "2":
                    window.location.href = data.result.results.api_url;
                    break;
                  default:
                    this.$message({
                      message: "暂不支持的支付类型！",
                      type: "warning"
                    })
                    break;
                }
                break;
              case 'magapp':
                this.magpay(data.result);
                break;
              default:
                this.$message({
                  message: "暂不支持的客户端！",
                  type: "warning"
                })
                break;
            }
          })
          .catch(error => {
            this.$message({
              message: error + "下单失败,请联系客服！",
              type: "warning"
            })
          });
      },
      checkorder(sn) {
        this.$api
          .request('Order/check', {
            sn
          })
          .then(({
            data
          }) => {
            this.$message({
              message: "支付成功",
              type: "warning"
            })
            this.$router.go(0);
          })
          .catch(error => {
            console.log(error)
          });
      },
      handleRadioChange(e) {
        this.payment = e;
      },
    }
  }
</script>


<style scoped lang="less">
  @import url("../../static/less/mine.less");

  .none {
    display: none !important;
  }

  .info_under .divide-line::after {
    border-right: rgba(0, 0, 0, 0) !important;
  }

  .radio-area {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 30px 0 0 0;
    flex-wrap: wrap;
  }

  .radio-item {
    padding-right: 7px;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  .btn-area {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .btn-area .btn {
    padding: 9px 15px;
  }

  .el-dialog {
    border-radius: 4px;
  }

  .dialog {}

  .dialog .el-dialog {
    padding-bottom: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/page/coupons.vue